import React from "react";
import '../Styles/Aim.css'
function AimAndObjective() {
  return (
    <div className="AimdBox">
      <h1 style={{textAlign: "center"}}>Aim And Objective</h1>
      <h3 className="AimContent">
        The aim of this academic centre is to address disturbances of different
        types at different scales in river systems. The academic activities of
        the Centre will focus on identifying ways to efficiently manage
        availability of the River for human uses while also identifying linkages
        between the River’s flow and quality and native aquatic and riparian
        eco-systems. The objective of the program is to provide information
        support, public wide debate, and an opportunity to allow the people to
        consider the possible consequences of interventions on the health of the
        rivers and enhance the potential for cooperation in the management of
        the vital economic and ecological services the river provides through
        teaching and research. Academic Programs Master of Science (M.Sc.) in
        River Science and Management (2 years) Six months certificate Programme
        in River Management Doctor of Philosophy in River Science The University
        welcomes fulltime M.Sc. Students as well as professionals from Govt.,
        Civil Society, Industry or any Social Movement or Organization.
      </h3>
    </div>
  );
}

export default AimAndObjective;
